// eslint-disable-next-line import/prefer-default-export
export const parametersGetters = {
    parameters(state) {
        return state.parameters
    },

    dates(state) {
        return state.dates
    },

    mainCalendarRefresh(state) {
        return state.main_calendar_refresh
    },

    show_date_selector(state) {
        return state.show_date_selector
    },
    
    auditDates(state) {
        return state.audit_dates
    },

    expertDates(state) {
        return state.expert_dates
    },

    expertCalendarRefresh(state) {
        return state.expert_calendar_refresh
    },

    niv2Dates(state) {
        return state.niv2_dates
    },

    niv2CalendarRefresh(state) {
        return state.niv2_calendar_refresh
    },

    parcCalendarRefresh(state) {
        return state.parc_calendar_refresh
    },

    parcDates(state) {
        return state.parc_dates
    },
    
    expert_pdm(state) {
        return state.expert_pdm
    },

    geo_pdm(state) {
        return state.geo_pdm
    },

    geo_timestep(state) {
        return state.timestep
    }
};
